import { apiRequest } from "./httpClient";

export async function listTranscriptSessions(username, token, roomId) {
    return apiRequest("api/transcripts/list-sessions", { token, body: { username, roomId } });
}

export async function getTranscriptSession(username, token, sessionId) {
    return apiRequest("api/transcripts/session", { token, body: { username, sessionId } });
}

export async function regenerateTranscriptSummary(username, token, sessionId) {
    return apiRequest("api/transcripts/regenerate-summary", { token, body: { username, sessionId } });
}
